var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2000 948",
    width: 500,
    height: 237,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1129,103)",
    d: "m0 0 2 1 1 3v82l-5 1v27l-6 1h-50l-2-1v-96l-117 1-9 3-6 5-5 9-2 15v62l-3 5-10 9-7 7-9 14-5 10-1 3 7-4 10-7 15-7 15-4 6-1h25l16 4 15 6 16 10 13 12 10 13 9 17 8 24 1 5h55l8-16 8-11 5-5 7-6 13-8 11-5 8-2h25l16 4 9 3-5-23-1-1-82-1-3-6 1-1h80l-4-9v-2h-114l-4-1-2-6 1-1 109-1-9-7-14-7-4-1-31-1-2-7v-15l1-6-6-1-1-86h27l40 3 29 4 40 9 46 12 3 2-3 25-4 23-12 48-11 33-13 33-10 19-12 24-3-3-3-6-7-2v-3l1-5-2-4-9-1-1-3 2-6-5-2-2-2-5 1-4 1v-5l-4-3-10-2-3-5-5-2h-4l-2 5-5-1-3-4-9 2-2 6-4-2-7 1-4 4v5h-3l-5-1-7 6 1 8-3 1-4-1-4 7 2 4v4l-6 2-2 4v7l3 3v2l-5 2-1 2v11l4 2-2 4-1 1 1 9 2 3 5 2-1 4-1 1v6l3 4 6 2v8l4 5 4 1 6-1-1 8 5 4h6l4-2 1 5 1 3 3 2 6-1 4-5h3l4 7 5 1 5-3 2-5 4 1 4 4 6-2 3-2v-6l2-1 5 3 5-2 5-1 2 4-4 5-5 4-4-1-3-2-2 7-5 3h-6l-5-4-3 6-5 2h-5l-5-7-4 2-3 3-7-1-6-3-15 10-24 13-19 8-27 9-24 6-25 4-19 2-17 1h-25l-40-3-28-4-26-6-11 1-46 8-59 9 1-3 17-10 18-12 13-8 1-2 4-29 6-31 8-30 11-36 8-20 11-25 12-23 12-21 14-20 12-16 9-9 5-7 1-60 5-12 7-7 8-4 5-1 123-1 22-4zm-185 150-7 2-2 2v6l-5-1-2-3-5 1-8 4-1 5 1 5-9-2-8 6-2 2 1 7 2 4-10-2-8 11 4 10-7 1-3 4-2 7 1 5 4 5v2l-7 2-1 5v10l7 6v2l-6 3 2 14 3 3 6 2-2 4-2 1 1 6 4 8 2 2 8-1-2 5-1 4 5 5 6 5 9-3-2 10 10 7 5-1 6-4v10l7 3 8 1 7-8h2l4 10 4 1 10-2 4-9v-2l5 5 2 3h6l9-5 1-4-1-6 10 5 9-7 2-2-2-9-1-3 8 2h5l7-10-1-5-2-1v-3l8-1 4-6 2-8-2-3h-2v-5l6-2 2-10v-6l-5-3h-2l4-4 3-2-1-12-2-4-5-2h-3l1-3 5-3-1-6-5-9h-9l3-5 1-4-8-11-2-1-9 3 3-7-1-4-8-7h-6l-6 3 1-9-3-3-8-3-4 1-3 4h-4l-1-7-1-1h-14l-4 6-3 1-2-7z",
    fill: "#41B157"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1129,103)",
    d: "m0 0 2 1 1 3v82l-5 1v27l-6 1h-50l-2-1v-96l-117 1-9 3-6 5-5 9-2 15v62l-3 5-10 9-7 7-9 14-5 10-1 3 7-4 10-7 15-7 15-4 6-1h25l16 4 15 6 16 10 13 12 10 13 9 17 1 5-7-1v2h-2v2h-2l-3-6-9-1 1-4 2-2-1-5-7-9-6 2h-4l2-10-8-7h-6l-3 2h-3v-9l-5-3-5-2-4 1-3 4-5-1-1-7h-14l-4 6h-3l-2-7-12 2-3 2v6l-4 1-4-4-5 1-6 3h-2l1 10-3 1-4-2-5 1-7 6 1 7 1 4-10-1-7 10 4 10-1 1-7 1-3 7-1 7 5 6-1 3-7 1v15l7 6-1 3-5 2 2 16 7 1 2 4-3 3h-2l5 13 2 2h8l-1 5-6 8-14 10-25 16-14 10-20 12-2 1v-17l5-29 6-26 10-35 10-30 11-25 11-23 10-18 11-18 13-18 9-12 9-9 5-7 1-60 5-12 7-7 8-4 5-1 123-1 22-4z",
    fill: "#056C40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(130,589)",
    d: "m0 0 70 1v22l-9 3-8 1v49l13-1 7-10 13-20 7-11 4-6 1-3-8-1-1-1v-22l23-1h23l23 1v22l-5 2-11 2-5 5-8 11-13 19-15 22-2 3 1 4 7 10 15 24 22 33 2 2 13 2 2 1 1 3v19l-7 1h-57l-5-1-1-6 1-16 9-1-4-8-14-22-12-19v-2l-19-1 1 50 14 2 2 2v21l-65 1-6-1v-21l2-2 15-2 1-133-14-2-4-2v-22z",
    fill: "#056B40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1656,577)",
    d: "m0 0h39l14 1v112l7-3 9-13 6-9 1-4-8-1-1-5v-16l1-1h58l6 1-1 20-7 3-8 2-10 15-10 14-1 5 9 15 13 22 8 13 7 2 5 2 1 1v21l-6 1-54-1v-21l6-2-2-5-10-17-6-11-2-1h-10l-1 32 14 2 1 2v21l-61 1-6-2v-22l15-2 1-146-17-2-1-1v-22z",
    fill: "#056C40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1104,577)",
    d: "m0 0h50l3 1 1 71 12-9 9-4 4-1h14l11 3 7 4 6 5 7 11 4 12 1 6 1 20v53l14 2 2 7v16l-5 1-62-1v-23l13-2v-70l-4-9-6-4-5-1h-7l-10 3-6 5-1 76 14 2 1 1v22l-64 1-3-2v-20l3-3 12-1 1-146-17-2-1-1v-22z",
    fill: "#076D41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,577)",
    d: "m0 0h52l1 4-1 70 11-9 12-6 5-1h14l13 4 9 7 6 8 5 12 2 9 1 26v48l15 2 2 2v21l-6 1-61-1-1-1v-20l1-2 12-2v-69l-4-10-6-4-5-1h-7l-10 3-6 5-1 8v68l14 2 1 1v22l-5 1h-51l-10-1-1-1v-22l16-2v-145l-17-3-1-1v-22z",
    fill: "#056B40"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(884,586)",
    d: "m0 0h27l16 4 15 6 14 9 5 6v37l-1 1h-26l-6-25-3-3-10-3-8-1h-18l-9 3-5 5-3 5-1 4v7l3 8 7 6 15 7 25 9 17 9 10 8 7 8 6 12 2 11v14l-3 13-6 10-9 9-10 6-11 4-9 2h-35l-17-5-15-8-13-11-1-2v-38l1-2h27l3 15 2 12 5 4 10 4 16 2 16-2 6-4 4-5 2-8v-7l-3-9-5-5-16-8-28-11-14-7-11-8-8-9-5-10-2-9v-16l4-13 6-9 4-5 13-9 12-5z",
    fill: "#046B3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1136,103)",
    d: "m0 0h27l40 3 29 4 40 9 42 11v3l-7 4-27 18-26 17-44 29-14 9-11 7 2 2v3l2 1-5-1-9-3-31-1-2-7v-15l1-6-6-1z",
    fill: "#01693E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1384,638)",
    d: "m0 0h59l4 1v15l-1 7-2 2-9 3 1 7 12 37 3 12 2 1 2-9 12-36 3-13-12-3-2-4 1-20h60l4 1v22l-6 2-5 2-8 18-14 40-9 26-14 40-10 21-7 9-6 5-8 4-3 1h-25l-4-2-1-4 2-11 1-11 2-2h8l9-2 6-7 5-13-2-10-14-39-9-24-12-34-3-5-10-3-1-7v-16z",
    fill: "#046B3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1305,635)",
    d: "m0 0h21l12 3 14 7 8 7 7 14 2 12v72l10 1 1 2v24h-41l-2-5-1-9-5 3-7 6-12 5h-24l-12-5-8-7-6-10-3-12v-14l3-10 6-8 7-6 12-6 11-3 34-1v-14l-2-8-2-5-6-2h-20l-5 2-3 13-1 1h-27v-29l5-5 15-8 13-4zm13 81-11 2-6 4-5 6-1 2v9l3 5 5 4 10 1 10-3 8-6 2-5v-17l-4-2z",
    fill: "#036A3E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1575,635)",
    d: "m0 0h20l16 4 10 6 7 6 6 9 4 11 1 79 9 1 1 1v24l-1 1h-40l-2-4-1-9-9 6-9 5-5 2h-25l-12-5-7-6-6-10-3-10v-19l4-11 8-9 11-6 16-5 34-1-1-16-3-9-6-4-10-1-14 2-3 3-2 12-18 1-9-1-1-1v-29l10-7 16-7zm11 81-9 2-7 4-5 6-1 3v7l3 6 5 4 11 1 10-3 7-6 2-6v-17l-3-1z",
    fill: "#036A3E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,635)",
    d: "m0 0h20l16 4 9 5 9 8 6 10 3 9 1 32v46l9 2 1 1v24l-1 1h-40l-2-5-1-8-5 3-10 7-9 3h-24l-10-4-10-9-6-12-2-8v-14l4-13 6-8 9-6 12-5 7-2 35-1-1-18-3-7-3-3-11-2-16 2-3 3-2 12h-27v-30l6-5 16-8 10-3zm12 81-10 2-8 5-5 7v8l3 6 3 3 7 2 11-1 8-4 6-7v-20l-6-1z",
    fill: "#036B3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(523,635)",
    d: "m0 0h23l18 4 11 5 6 4 2 2v34h-25l-3-15-5-5-8-3-10-1-10 4-4 6v9l3 5 8 4 27 8 16 8 8 7 5 7 2 6 1 7v9l-3 12-8 11-9 7-11 5-8 2h-32l-13-4-14-7-5-4-1-2v-31h25l3 8 3 10 5 3 6 2h14l8-4 4-5v-9l-3-5-10-5-22-7-15-6-10-7-7-10-3-8v-16l4-11 9-12 10-7 12-4z",
    fill: "#036B3F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(302,638)",
    d: "m0 0h47l4 1 1 14 5-5 8-7 6-3h19v10l-2 22-1 1-18 1-8 3-6 5-1 2v67l14 2 1 1 1 8v14l-7 1-62-1v-18l2-5 6-1h8v-85l-17-3-1-1v-22z",
    fill: "#066D41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(399,638)",
    d: "m0 0h53l1 1 1 110 12 2 3 2 1 20-2 2h-60l-7-1-1-1v-20l2-2 14-2v-83l-17-4-1-7z",
    fill: "#046C3F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,638)",
    d: "m0 0h53l1 1 1 111h8l6 2 2 7v14l-2 2h-64l-3-1v-22l7-2h9v-83l-6-2-11-3-1-1z",
    fill: "#056D40"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1027,127)",
    d: "m0 0h34v60l-1 9-10 10-4-1-8-10v-3l8-5v-2l-5 1-8 6-8 7-1 3 5-1 2-2 5 1 7 10-3 5-6 2h-26l-1-3v-84l1-2z",
    fill: "#0C7145"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(957,313)",
    d: "m0 0 11 1 10 4 7 6 6 10 3 9v15l-4 11-7 9-6 5-11 4h-11l-10-3-8-6-6-8-4-8-2-12 2-13 5-10 9-9 9-4zm0 26-6 5-1 2v8l4 5 7 2 7-4 2-4-1-9-3-4z",
    fill: "#036B3F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(993,128)",
    d: "m0 0h7v89h-17l-8-13-13-25-1-3h-12v41h-12v-36l3-3 1-10 5-1h6l14-10 10-7 13-8 3-1v-12z",
    fill: "#066E40"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1188,335)",
    d: "m0 0 11 2 8 5 5 6 3 6 1 4v13l-3 7-4 6-8 6-7 2h-8l-8-2-6-4-5-6-3-5-1-4v-15l5-10 7-7 8-3zm1 17-6 3-3 5v8l5 6 2 1h6l6-5 1-2v-7l-3-6-5-3z",
    fill: "#45B35A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,577)",
    d: "m0 0h22l13 1v27l-1 1h-35v-28z",
    fill: "#086F42"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(769,577)",
    d: "m0 0h34l2 3-1 26h-35l-1-9z",
    fill: "#0B7044"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(352,816)",
    d: "m0 0h81l2 4-1 3h-82l-1-4z",
    fill: "#46B35C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1489,816)",
    d: "m0 0h81v7h-82v-6z",
    fill: "#42B158"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(899,347)",
    d: "m0 0h2l3 16 5 13 5 9 8 10 9 7 12 5 10 2h16l13-3 10-5 10-9 6-8 6-13 3-12 1-9 3 2v10l-5 14-7 12-7 9-9 7-14 7-8 2h-20l-13-3-10-5-12-11-9-13-6-13-2-8z",
    fill: "#63BF75"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1238,359)",
    d: "m0 0h3l-1 13-3 10-6 11-6 7h-2l-1 3-10 6-15 4h-19l-13-5-9-7-8-11-7-15-3-14h4l5 19 7 13 6 7 10 6 5 2 6 1h19l10-3 11-7 8-10 4-8 4-16z",
    fill: "#BFE4C7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1018,350)",
    d: "m0 0 3 2v10l-5 14-7 12-7 9-9 7-14 7-3-1 3-3 10-4 9-7 9-10 7-15 3-12z",
    fill: "#74C684"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1218,422)",
    d: "m0 0 5 2h4l3-2 5 1 1 3-4 5-5 4-4-1-7-3 1-2v-6z",
    fill: "#64BC78"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1238,359)",
    d: "m0 0h3l-1 13-3 10-6 11-6 7h-2l-1 3-3 2-3-1 5-5 8-10 4-8 4-16z",
    fill: "#69C27A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1247,409)",
    d: "m0 0 1 4-7 10-5-1-3-3-1-8 8 1z",
    fill: "#57BA6A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1254,393)",
    d: "m0 0h2l-1 6-5 8-2 1v-3l-4-2-1-4 8-4z",
    fill: "#6DC27F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1139,360)",
    d: "m0 0 3 1 5 19 1 2v6l-3-4-5-12-2-11z",
    fill: "#72C582"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(899,347)",
    d: "m0 0h2l3 16 2 9-3 1-4-13z",
    fill: "#60BD73"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1215,403)",
    d: "m0 0 2 1-1 3-10 4-7 1h-15l-2-2 18-1 10-3z",
    fill: "#F4F9F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1119,88)",
    d: "m0 0 6 2 3 4v3h-6l-4-3-1-5z",
    fill: "#3C9365"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1258,377)",
    d: "m0 0h2l-1 9-1 2-5-1-2-4 5-5z",
    fill: "#71C581"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1148,384)",
    d: "m0 0 3 4 7 10 6 5h-3l-4-1-9-12z",
    fill: "#DFF1E2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1238,359)",
    d: "m0 0h3l-1 13-2 1-3 7-1-2z",
    fill: "#E6F3E8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(990,402)",
    d: "m0 0 2 1-4 4-9 4-3-1 3-3 10-4z",
    fill: "#8DD09A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1177,410)",
    d: "m0 0 13 1h9l-2 2h-19z",
    fill: "#60BE72"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1018,350)",
    d: "m0 0 3 2v10l-1 3h-2l-1-6z",
    fill: "#43A462"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,360)",
    d: "m0 0h1l1 9-3 7h-3z",
    fill: "#64B77B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1238,369)",
    d: "m0 0h1v7l-3 8-4 1 2-5 3-7z",
    fill: "#7AC889"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1014,375)",
    d: "m0 0 1 3-6 10-2-2 5-10z",
    fill: "#7AC889"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1254,360)",
    d: "m0 0h4l1 6-3 1-3-3z",
    fill: "#86CD94"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1215,403)",
    d: "m0 0 2 1-1 3-4 2h-5l3-3z",
    fill: "#B3DFBC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1252,342)",
    d: "m0 0h2l-1 5-3-1z",
    fill: "#B3DFBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorNew);
export default __webpack_public_path__ + "static/media/vectorNew.864b9c1025c93a680dffb9bbe5b238da.svg";
export { ForwardRef as ReactComponent };